import { render } from "./manage-value.vue?vue&type=template&id=9acb129e"
import script from "./manage-value.vue?vue&type=script&lang=js"
export * from "./manage-value.vue?vue&type=script&lang=js"

import "./manage-value.vue?vue&type=style&index=0&id=9acb129e&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__